import { FunctionComponent } from "react";
import NAV from "../components/NAV";
const Lesson3: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.5rem] text-white font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between text-[1.56rem] text-darkgray">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson2"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative">Forex Markets</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson4"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-start gap-[8.5rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-[1.88rem] font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[3.94rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>What Is The Forex Market</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  The forex (FX) market has many similarities to the equity
                  markets. However, there are also some key differences. This
                  article will show you those differences and help you get
                  started in forex trading.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  If you've decided to take a stab at forex trading, the good
                  news is that access to the currency markets has never been
                  easier. A wide range of online brokerage platforms offer
                  everything from spot trading to futures and CFDs.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[31.31rem] h-[27.56rem] object-cover"
            alt=""
            src="/i9@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>KEY TAKEAWAYS</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  To settle on a forex broker, do your due diligence and make
                  sure you choose one who can meet your trading needs now and
                  over time.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Look for low spreads and fees from a provider in a
                  well-regulated jurisdiction.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Compare the types of trading platforms, trading and analysis
                  tools, access to leverage, and more.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Before trading, study basic forex strategies and learn how to
                  analyze currency markets properly.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Consider starting with a demo account to try out and backtest
                  your strategy before risking real money in the market.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
         
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Forex brokers usually don't charge a commission. Instead, they
                make their money on the spread. So look for a lower spread. When
                comparing forex brokers, you may find a large range of spreads.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-[1.56rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>
                  Choose a Broker Who's Backed by Regulatory Agencies and a
                  Reliable Institution
                </span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Unlike equity brokers, forex brokers are usually tied to large
                  banks or lending institutions because of the large amounts of
                  capital required (leverage that they need to provide).
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Also, a forex broker should be registered as a Futures
                  Commission Merchant (FCM) and regulated by the Commodity
                  Futures Trading Commission (CFTC).12 You can check on this and
                  other financial information and statistics at a forex
                  brokerage website, the website of its parent company, or
                  through BrokerCheck at the Financial Industry Regulatory
                  Authority (FINRA) website.
                </span>
              </span>
            </p>
          </div>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-[1.56rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>Get the Tools You Need to Succeed</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              Forex brokers offer different trading platforms for use by their
              clients*—*just like brokers in other markets. These trading
              platforms usually feature real-time charts, technical analysis
              tools, real-time news and data, and even support for trading
              systems.
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              As part of your broker selection process, be sure to request free
              trials to test the different trading platforms. Brokers will also
              provide technical and fundamental information, economic calendars,
              and other extensive research.
            </p>
          </div>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-[1.56rem] text-gainsboro-100">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem] text-white">
              <b>Leverage Your Bets</b>
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              Leverage is necessary in forex because the price deviations (the
              sources of profit) are merely fractions of a cent. Leverage,
              expressed as a ratio between total capital available to actual
              capital, is the amount of money a broker will lend you for
              trading. For example, a ratio of 100:1 means your broker would
              lend you $100 for every $1 of actual capital. Many brokerages
              offer a ratio of 250:1. So give leverage some thought. Bear in
              mind that while less leverage means lower risk of a margin call,
              it also means less bang for your buck.
            </p>
            <p className="m-0">&nbsp;</p>
            <p className="m-0">
              If you have limited capital, consider a brokerage that offers high
              leverage through a margin account. If you have plenty of capital,
              any broker with a wide variety of leverage options should do. A
              variety of options lets you vary the amount of risk you are
              willing to take. For example, less leverage (and therefore less
              risk) may be preferable for highly volatile (exotic) currency
              pairs.
            </p>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>
              Choose a Broker With Appropriate Leverage, Tools, and Services for
              Your Capital
            </b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Many brokers offer two or more types of accounts. The smallest
            account is known as a mini account. It requires you to trade with a
            minimum of, say, $250 and offers a high amount of leverage (which
            you need in order to make money with this size of initial capital).
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The standard account lets you use different degrees of leverage, but
            has an account minimum of $2,000. Premium accounts, which often
            require significantly higher amounts of capital, let you use
            different amounts of leverage and often offer additional tools and
            services.
          </p>
        </div>
        <b className="self-stretch relative text-[2.81rem] inline-block font-nunito text-center h-[3rem] shrink-0">
          Forex Broker Actions to Avoid
        </b>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Sniping and Hunting</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Sniping and hunting are the premature buying or selling of
                currency near preset points. They are inappropriate activities
                used to increase profits. The only way to determine the brokers
                that do this is to talk to fellow traders. There is no blacklist
                or organization that reports such activity.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Suspect Margin Rules</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When you are trading with borrowed money, your forex broker has
                a say in how much risk you take. As such, your broker can buy or
                sell at their discretion, which can affect you negatively.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Let's say you have a margin account, and your position suffers a
                sudden drop before rebounding to all-time highs. Even if you
                have enough cash to cover the change in value, some brokers will
                liquidate your position on a margin call at the low. Their
                action can cost you a significant amount of capital.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Be sure to conduct thorough due diligence prior to selecting a
                broker. Once you've made your selection, signing up for a forex
                account is similar to getting an equity account.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The only major difference is that for forex accounts, you are
                required to sign a margin agreement. This agreement states that
                you will be trading with borrowed money and, as such, the
                brokerage has the right to intervene in your trades to protect
                its interests. That said, once you sign up and fund your
                account, you'll be ready to trade.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Define Your Method of Analysis</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Technical analysis and fundamental analysis are two methods used
                by forex traders to help them determine when to enter and exit
                the forex market. Technical analysis is by far the more commonly
                used.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Fundamental Analysis</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you think it's difficult to value one company, try valuing a
                whole country. Fundamental analysis in the forex market is very
                complex. It's often used only to predict long-term trends.
                However, some traders do trade short term strictly on news
                releases. Fundamental indicators of currency values are released
                at different times. These include:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Non-farm Payrolls</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Purchasing Managers' Index (PMI)</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Consumer Price Index (CPI)5</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Retail Sales</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Durable Goods</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                These reports are not the only economic announcements to watch.
                News coverage of, and press releases from, relevant government
                agency meetings can also move markets. For example, the Federal
                Reserve chair's comments on interest rates can cause market
                volatility.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                These regular gatherings involve discussion of monetary policy,
                interest rates, inflation, and other issues that affect currency
                valuations.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Therefore, it's important that forex traders be aware of the
                various economic reports to Congress including those made by the
                Federal Open Market Committee (FOMC) and the Humphrey-Hawkins
                Report8.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Reading the reports and examining the commentary can help forex
                fundamental analysts gain a better understanding of long-term
                market trends. Short-term traders may learn to profit from
                extraordinary events.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you choose to use fundamental analysis, be sure to keep an
                economic calendar handy at all times so you know when these
                reports are released. Your trading platform or broker may also
                give you real-time access to the release of economic data.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Technical Analysis</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Forex technical analysts analyze price trends, similar to their
                counterparts in the equity markets. The key difference between
                technical analysis in forex and in equities is timeframe. Forex
                markets are open 24 hours a day.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                As a result, certain technical analysis tools that factor in
                time must be modified for the 24-hour period. Here are some of
                the most common forms of technical analysis used in forex:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>The Elliott Waves</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Fibonacci Studies</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Parabolic SAR</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Pivot points</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Many technical analysts combine these studies to make more
                accurate predictions (e.g., the common practice of combining
                Fibonacci studies with Elliott Waves). Others create trading
                systems to repeatedly locate similar buying and selling
                conditions.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Develop Your Forex Trading Strategy</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Most successful traders develop a strategy and perfect it over
                time. Some focus on one particular study or calculation, while
                others use broad spectrum analysis to determine their trades.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Experts suggest trying a combination of both fundamental and
                technical analysis in order to make long-term projections and
                determine short-term entry and exit points. That said,
                individual traders must decide what works best for them, often
                through trial and error.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>Added Considerations</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>
                    Open a demo account and paper trade until you can make a
                    consistent profit.
                  </b>
                  <span>
                    {" "}
                    Many people jump into the forex market and quickly lose a
                    lot of money due to taking on too much leverage. It is
                    important to take your time and learn to trade properly
                    before committing capital.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Trade without emotion. `}</b>
                  <span>
                    Avoid mental stop-loss points if you don't have the ability
                    to execute them on time. Always set your stop-loss and
                    take-profit points to execute automatically. Don't change
                    them unless absolutely necessary.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b className="font-dm-sans">The trend can be your friend.</b>
                  <span>
                    {" "}
                    If you go against the trend, make sure you have a good
                    reason. That's because you have a higher chance of success
                    when trading with the general trend of the forex market.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>What Is Forex Trading?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Forex trading is the exchange (or trading) of currencies on the
                foreign exchange market. Trading occurs in currency pairs such
                as the EUR/USD (the euro versus the U.S. dollar) and the USD/CAD
                (the U.S. dollar versus the Canadian dollar). The foreign
                exchange market is the most actively traded market in the world.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>What Is Forex Trading?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Forex trading is the exchange (or trading) of currencies on the
                foreign exchange market. Trading occurs in currency pairs such
                as the EUR/USD (the euro versus the U.S. dollar) and the USD/CAD
                (the U.S. dollar versus the Canadian dollar). The foreign
                exchange market is the most actively traded market in the world.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>What Is Forex Trading?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Forex trading is the exchange (or trading) of currencies on the
                foreign exchange market. Trading occurs in currency pairs such
                as the EUR/USD (the euro versus the U.S. dollar) and the USD/CAD
                (the U.S. dollar versus the Canadian dollar). The foreign
                exchange market is the most actively traded market in the world.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>What's a Forex Demo Account?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                It's an account offered by some firms that let traders and
                investors test out their trading or investing skills in a
                no-pressure atmosphere without real money. A demo account lets
                you simulate real trades and test strategies without the fear of
                actual financial loss. You also have the chance to get used to
                the broker's trading platform technology. Beginning and
                experienced traders and investors use demo accounts.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>The Bottom Line</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The forex market is the largest financial market in the world
                with a daily volume of $6.6 trillion.9 Individuals have become
                increasingly interested in earning a living trading foreign
                exchange.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, there's a lot to consider before you begin trading. You
                want to be sure that your broker meets certain regulatory and
                financial criteria. You need to find the right trading strategy
                for your objectives. Bear in mind that one way to learn to trade
                forex is with a demo account. Use one to practice trading until
                you're confident enough to use real funds.
              </span>
            </span>
          </p>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300" 
      href="/lesson4">
        <div className="w-full">
        <b className="inline-block flex-1 w-full relative text-center pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson3;
